export default __webpack_public_path__ + "static/media/dashboard_black_24dp.65d3659d.svg";